import { useTranslation } from 'summon-ui/intl'
import { Modal, Button } from 'summon-ui/mantine'
import ConnectToSocial, { SocialType } from '@components/ConnectToSocial'
import useCheckTaskCompletion from '@features/quests/hooks/useCheckTaskCompletion'
import { TaskWithQuestId } from '@features/quests/types'

interface Props {
  task: TaskWithQuestId
  checkStatus: () => void
}

const ActionButtonCheck = ({ task }: Props) => {
  const t = useTranslation()
  const { checkTaskCompletionMutation, isCheckTaskCompletionLoading, socialConnect, setSocialConnect } =
    useCheckTaskCompletion({ task })

  const handleActionCheck = () => {
    checkTaskCompletionMutation({ questId: task.questId as string, taskId: task.id })
  }

  return (
    <>
      <Button
        onClick={handleActionCheck}
        loading={isCheckTaskCompletionLoading}
        disabled={isCheckTaskCompletionLoading}
        variant='outline'
      >
        {t('Check Status')}
      </Button>

      <Modal maw={400} opened={!!socialConnect} onClose={() => setSocialConnect(null)}>
        <ConnectToSocial type={socialConnect as SocialType} close={() => setSocialConnect(null)} />
      </Modal>
    </>
  )
}

export default ActionButtonCheck
